import React, { useEffect, useMemo, useState } from "react";
import { MdLogin, MdLogout, MdPeople } from "react-icons/md";
import avatar from "assets/img/avatars/avatar4.png";
import Avatar from "components/avatar";
import Badge from "components/badge";
import DataTable from "components/data-table";
import StatCard from "components/stat-card";
import { SearchInput, Select } from "components/fields";
import { PageContainer, PageHeader } from "components/page";
import { EmptyState } from "components/states";
import { formatDateTime, formatNumber } from "utils/format";

const STATS = [
  { label: "Total Members", count: 8412, icon: MdPeople, accent: "sage" },
  { label: "Entry", count: 8412, icon: MdLogin, accent: "sage" },
  { label: "Exit", count: 8412, icon: MdLogout, accent: "danger" },
];

const ROLE_OPTIONS = [
  { value: "", label: "All Roles" },
  { value: "Volunteer", label: "Volunteer" },
  { value: "Admin", label: "Admin" },
];

const TIME_OPTIONS = [
  { value: "", label: "All Time" },
  { value: "Today", label: "Today" },
  { value: "This Week", label: "This Week" },
];

const COLUMNS = [
  {
    id: "name",
    header: "Name",
    cell: ({ row }) => (
      <div className="flex items-center gap-3">
        <Avatar src={row.original.avatar} name={row.original.name} size="md" noBorder />
        <div className="flex min-w-0 flex-col">
          <span className="font-semibold text-fg">{row.original.name}</span>
          <span className="text-sm text-fg-muted">{row.original.role}</span>
        </div>
      </div>
    ),
  },
  { accessorKey: "service", header: "Services" },
  {
    id: "datetime",
    header: "Date and Time",
    cell: ({ row }) => formatDateTime(row.original.datetime),
  },
  {
    id: "type",
    header: "Type",
    cell: ({ row }) => (
      <Badge tone={row.original.type === "Exit" ? "danger" : "success"}>{row.original.type}</Badge>
    ),
  },
];

const EntriesAndExits = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [role, setRole] = useState("");

  useEffect(() => {
    setData([
      {
        name: "Vlad Mihalache",
        avatar: avatar,
        role: "Volunteer",
        service: "Service Name",
        datetime: new Date(),
        type: Math.random() > 0.5 ? "Entry" : "Exit",
      },
      {
        name: "John Smith",
        avatar: avatar,
        role: "Volunteer",
        service: "Service Name",
        datetime: new Date(),
        type: Math.random() > 0.5 ? "Entry" : "Exit",
      },
      {
        name: "Emma Johnson",
        avatar: avatar,
        role: "Volunteer",
        service: "Service Name",
        datetime: new Date(),
        type: Math.random() > 0.5 ? "Entry" : "Exit",
      },
    ]);
  }, []);

  const rows = useMemo(() => {
    const query = search.trim().toLowerCase();
    return data.filter(
      (row) => (!query || row.name.toLowerCase().includes(query)) && (!role || row.role === role)
    );
  }, [data, search, role]);

  return (
    <PageContainer>
      <PageHeader title="Entries and Exits" />

      <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
        {STATS.map((stat) => (
          <StatCard
            key={stat.label}
            icon={stat.icon}
            accent={stat.accent}
            label={stat.label}
            value={formatNumber(stat.count)}
          />
        ))}
      </div>

      <div className="flex flex-wrap items-end gap-2">
        <SearchInput
          value={search}
          onChange={setSearch}
          placeholder="Find by user name"
          ariaLabel="Find by user name"
          className="w-full md:w-80"
        />
        <Select
          aria-label="Role"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          options={ROLE_OPTIONS}
          className="w-full sm:w-44"
        />
        <Select
          aria-label="Time range"
          defaultValue=""
          options={TIME_OPTIONS}
          className="w-full sm:w-44"
        />
      </div>

      <DataTable
        aria-label="Entries and exits"
        columns={COLUMNS}
        data={rows}
        pagination
        emptyState={<EmptyState variant="filtered" />}
      />
    </PageContainer>
  );
};

export default EntriesAndExits;
